/**
 * @param file The File, Blob, or filename.
 * @returns The MIME type of the file or `undefined`.
 * TODO: Move to @eigtech/ui-shared-documents
 */
export function getMediaMimeType(file: File | Blob | string): string | undefined {
  if (file instanceof File || file instanceof Blob) {
    return file.type
  }

  return getMimeTypeByExtension(file)
}

export const getMimeTypeByExtension = (filename: string) => {
  const ext = filename.split('.').pop()?.toLowerCase()

  const mimeMap: Record<string, string> = {
    // Images
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    bmp: 'image/bmp',
    tiff: 'image/tiff',
    tif: 'image/tiff',
    svg: 'image/svg+xml',
    heic: 'image/heic',
    heif: 'image/heif',

    // Videos
    mp4: 'video/mp4',
    webm: 'video/webm',
    ogg: 'video/ogg',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
    mkv: 'video/x-matroska',
    m4v: 'video/x-m4v',
    mpeg: 'video/mpeg',
    mpg: 'video/mpeg',
    '3gp': 'video/3gpp',
    '3g2': 'video/3gpp2',
  }

  return ext ? mimeMap[ext] : undefined
}
